export default {
  Success: 0,
  Error: 1,
  InvalidData: 2,
  Arisened: 3,
  PartInvalidData: 4,
}
